module.exports = __webpack_public_path__ + "8a37862a5fcc84b5b41315df44fc5c95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000UW6.png
// module id = 1637
// module chunks = 0